const ExEDConstants = {
  PRODUCT_FOLDER_MAP : {
    'en': 'programmes-for-individuals',
    'fr': 'programmes-pour-les-individus'
  }
};

module.exports = {
  ExEDConstants
};